import useIsMobile from '@/helpers/commonHooks/useIsMobile'
import FreeTrialPageMobile from './components/FreeTrialPageMobile/FreeTrialPageMobile'
import FreeTrialPagePc from './components/FreeTrialPagePc/FreeTrialPagePc'
import { observer } from 'mobx-react'
import { userService } from '@/services/userService'
import { useLocation } from 'react-router-dom'

function FreeTrialPage() {
  const isMobile = useIsMobile()
  const userInfo = userService.userInfo
  const location = useLocation()
  const forStatus = location.state?.forStatus
  return userInfo
    ? isMobile ? <FreeTrialPageMobile userInfo={userInfo} forStatus={forStatus} /> : <FreeTrialPagePc userInfo={userInfo!} />
    : null
}

export default observer(FreeTrialPage)